import toArray from 'lodash/toArray';
import get from 'lodash/get';
import forEach from 'lodash/forEach';
import keyBy from 'lodash/keyBy';

import { caseLogicMsg } from '../validationMessages';

function validateCustomStateNodes(caseConf) {
  const nodes = toArray(get(caseConf, 'caseLogicDescription.nodes'));
  const errors = [];
  const warnings = [];
  const customStatesById = keyBy(get(caseConf, 'caseLogicDescription.customStates'), 'id');

  nodes.forEach((node) => {
    if (node.name === 'Effect' && get(node, 'data.effect.type') === 'CUSTOM_STATE') {
      if (node.data.effect.value === undefined || node.data.effect.value === null) {
        warnings.push(
          caseLogicMsg('Custom state value is mandatory', node.id)
        );
      }
      if (!node.data.effect.id) {
        errors.push({
          message: 'Custom state is mandatory',
          category: 'caseLogic',
          field: 'caseLogicDescription',
          id: node.id,
        });
      } else if (!customStatesById[node.data.effect.id]) {
        errors.push({
          message: 'Custom state no longer exists, this node must be removed',
          category: 'caseLogic',
          field: 'caseLogicDescription',
          id: node.id,
        });
      }
    } else if (node.name === 'Check') {
      forEach(node.data, (check, checkKey) => {
        if (check.type === 'CUSTOM_STATE') {
          if (!check.id) {
            errors.push({
              message: 'Custom state is mandatory',
              category: 'caseLogic',
              field: 'caseLogicDescription',
              id: node.id,
              metadata: {
                checkKey,
              },
            });
          } else if (!customStatesById[check.id]) {
            errors.push({
              message: 'Custom state no longer exists, this check must be removed',
              category: 'caseLogic',
              field: 'caseLogicDescription',
              id: node.id,
              metadata: {
                checkKey,
              },
            });
          }
        }
      });
    }
  });
  return {
    errors,
    warnings,
  };
}

export default validateCustomStateNodes;
